import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography } from 'ui-kit';
import Stack from 'ui-kit/Stack';

import videoFile from './onboarding.mp4';
import posterFile from './poster.png';
import './styles.scss';

interface IProps {
  onNext: () => void;
}

const OnboardingVideo = ({ onNext }: IProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      videoRef.current
        ?.play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch(() => undefined);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoClick = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
    }
  };

  return (
    <Stack
      flexDirection="column"
      className="OnboardingVideo"
      gap="1rem"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h4" className="OnboardingVideo__title" color="primary">
        You’re in! Watch this one-minute video to get launched fast.
      </Typography>
      <div className="OnboardingVideo__video-container">
        <video
          muted
          playsInline
          controls={isPlaying}
          ref={videoRef}
          poster={posterFile}
          className="OnboardingVideo__video"
          onClick={handleVideoClick}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        >
          <source src={videoFile} type="video/mp4" />
        </video>

        {/* Play Button Overlay */}
        {!isPlaying && (
          <button onClick={handlePlay} className="OnboardingVideo__play-button">
            <svg style={{ width: '44px', height: '44px', color: 'white' }} viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>
        )}
      </div>
      <Button onClick={onNext} variant="contained">
        Next
      </Button>
    </Stack>
  );
};

export default OnboardingVideo;
